import L from 'leaflet';
import { mergeClasses } from '@griffel/react';
import { MAP_DEFAULT_ZOOM } from '../map/MapConstants';

export default class ConstructionPin extends L.Marker 
{
    constructor(latlng, options = {}) 
    {
        super(latlng, options);

        this._zoomLevel = MAP_DEFAULT_ZOOM;

        this.initVars(options);
        this.setIcon(this.createIcon(options));

        this.on('click', () =>
        {
            if (this.onClick) this.onClick();
        }
        );
    }

    initVars(options = {}) 
    {
        this._markerClassName = mergeClasses('map-pin', 'common', 'construction');
    }

    createIcon(options = {}) 
    {
        return L.divIcon(
        {
            className: this._markerClassName,
            html: this.makeHTML(options)
        }
        );
    }

    makeHTML(options = {}) 
    {
        return `<div class="pin-inner"><img src="${process.env.PUBLIC_URL}/img/icon_construction.png" /></div>`;
    }

    handleUpdateZoom()
    {
        // Implement zoom level related updates here
    }

    get zoomLevel()
    {
        return this._zoomLevel;
    }

    set zoomLevel(value)
    {
        this._zoomLevel = value;
        this.handleUpdateZoom();
    }
}